"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VOLT_PALETTE_DARK = exports.VOLT_PALETTE_LIGHT = void 0;
exports.blockDiagramColorsByName = blockDiagramColorsByName;
const voltage_1 = require("../layout/voltage");
exports.VOLT_PALETTE_LIGHT = [
    '#c62828',
    '#d84315',
    '#a85e00',
    '#2e7d32',
    '#00796b',
    '#1565c0',
    '#6a3ab2',
];
exports.VOLT_PALETTE_DARK = [
    '#ef5350',
    '#ff7043',
    '#e0a030',
    '#66bb6a',
    '#26a69a',
    '#42a5f5',
    '#ab7ce8',
];
function blockDiagramColorsByName(theme) {
    const light = theme === 'light';
    const palette = light ? exports.VOLT_PALETTE_LIGHT : exports.VOLT_PALETTE_DARK;
    const colors = {
        'edge-labels': light ? '#fcfdfd' : '#252b31',
        'block-name': light ? '#1c242c' : '#e4e9ed',
        'block-sub': light ? '#5d6b76' : '#9aa7b1',
        'block-outline-processor': light ? '#1c242c' : '#dfe6ec',
        'block-outline-power': light ? '#b8860b' : '#d4a72c',
        'block-outline-connector': light ? '#4285f4' : '#6ba3f8',
        'block-outline-generic': light ? '#64748b' : '#8b9bb0',
        'block-fill-processor': light ? '#f1f4f6' : '#232a31',
        'block-fill-power': light ? '#fdf3d8' : '#332b18',
        'block-fill-connector': light ? '#e8f0fe' : '#1c2940',
        'block-fill-generic': light ? '#f1f4f6' : '#232a31',
        'rail-unranked': light ? '#b8860b' : '#d4a72c',
        'edge-bus': light ? '#44545f' : '#9fb2bf',
        'edge-control': light ? '#7c8b97' : '#7f909d',
        'edge-analog': light ? '#7c8b97' : '#7f909d',
        'board-label': light ? '#8b99a4' : '#77848f',
        'board-outline': light ? '#b6c1c9' : '#48545e',
    };
    for (let rank = 0; rank < voltage_1.VOLTAGE_RANK_COUNT; rank++) {
        colors[`rail-rank-${rank}`] = palette[rank];
    }
    return colors;
}
//# sourceMappingURL=colors.js.map